const PROCESSING_TOAST_ID = "greenone-processing-toast";
const SUCCESS_HIDE_DELAY_MS = 1800;
const STACKED_TOAST_HIDE_DELAY_MS = 4000;
const STACK_TOP_OFFSET = 88;
const STACK_GAP = 12;
const APP_NOTIFICATION_DELAY_MS = 400;

let appNotificationQueue = [];
let appNotificationTimer = null;

const TOAST_CONFIG = {
  processing: { background: "#d98200", icon: "spinner" },
  success: { background: "#0b8f08", icon: "check" },
  confirmation: { background: "#0b8f08", icon: "check" },
  error: { background: "#d12", icon: "error" },
  warning: { background: "#d98200", icon: "error" },
  info: { background: "#026F6D", icon: "error" },
};

let stackedToasts = [];

function removeProcessingToast() {
  const existing = document.getElementById(PROCESSING_TOAST_ID);
  if (existing) {
    existing.remove();
  }
}

function repositionStackedToasts() {
  let top = STACK_TOP_OFFSET;

  stackedToasts.forEach(({ el }) => {
    el.style.top = `${top}px`;
    top += el.offsetHeight + STACK_GAP;
  });
}

function removeStackedToast(el) {
  const index = stackedToasts.findIndex(entry => entry.el === el);
  if (index === -1) return;

  const [{ timer }] = stackedToasts.splice(index, 1);
  if (timer) window.clearTimeout(timer);

  el.style.opacity = "0";
  el.style.transform = "translateX(24px)";

  window.setTimeout(() => el.remove(), 250);

  repositionStackedToasts();
}

function createCloseButton(onClick) {
  const button = document.createElement("button");
  button.type = "button";
  button.setAttribute("aria-label", "Meldung schliessen");
  button.innerHTML = "×";

  button.style.border = "0";
  button.style.background = "transparent";
  button.style.color = "#fff";
  button.style.fontSize = "32px";
  button.style.lineHeight = "1";
  button.style.cursor = "pointer";
  button.style.padding = "0";
  button.style.marginLeft = "12px";

  button.onclick = onClick;

  return button;
}

function appendToastIcon(wrapper, icon) {
  const iconWrap = document.createElement("div");
  iconWrap.style.width = "28px";
  iconWrap.style.height = "28px";
  iconWrap.style.minWidth = "28px";
  iconWrap.style.display = "flex";
  iconWrap.style.alignItems = "center";
  iconWrap.style.justifyContent = "center";

  if (icon === "spinner") {
    const spinner = document.createElement("sdx-loading-spinner");
    spinner.style.transform = "scale(0.75)";
    spinner.style.filter = "brightness(0) invert(1)";
    iconWrap.appendChild(spinner);
  }

  if (icon === "check") {
    iconWrap.innerHTML = `
      <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden="true">
        <circle cx="14" cy="14" r="11.5" fill="none" stroke="white" stroke-width="2.5"></circle>
        <path d="M8 14.5L12 18.5L20.5 9.5" fill="none" stroke="white" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;
  }

  if (icon === "error") {
    iconWrap.innerHTML = `
      <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden="true">
        <circle cx="14" cy="14" r="11.5" fill="none" stroke="white" stroke-width="2.5"></circle>
        <path d="M9 9L19 19M19 9L9 19" fill="none" stroke="white" stroke-width="2.8" stroke-linecap="round"></path>
      </svg>
    `;
  }

  wrapper.appendChild(iconWrap);
}

function styleToastWrapper(wrapper, config) {
  wrapper.style.zIndex = "2147483647";
  wrapper.style.minWidth = "280px";
  wrapper.style.maxWidth = "520px";
  wrapper.style.borderRadius = "8px";
  wrapper.style.background = config.background;
  wrapper.style.color = "#fff";
  wrapper.style.padding = "18px 20px";
  wrapper.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.18)";
  wrapper.style.display = "flex";
  wrapper.style.alignItems = "center";
  wrapper.style.gap = "14px";
  wrapper.style.fontSize = "16px";
  wrapper.style.lineHeight = "1.4";
  wrapper.style.boxSizing = "border-box";
}

function createToast({
  type = "processing",
  message,
  closable = false,
  autoHide = false,
} = {}) {
  removeProcessingToast();

  const config = TOAST_CONFIG[type] || TOAST_CONFIG.info;

  const wrapper = document.createElement("div");
  wrapper.id = PROCESSING_TOAST_ID;
  wrapper.setAttribute("role", type === "error" ? "alert" : "status");
  wrapper.setAttribute("aria-live", type === "error" ? "assertive" : "polite");

  wrapper.style.position = "fixed";
  wrapper.style.top = "88px";
  wrapper.style.right = "24px";
  styleToastWrapper(wrapper, config);

  appendToastIcon(wrapper, config.icon);

  const text = document.createElement("div");
  text.textContent = message;
  text.style.flex = "1";
  text.style.fontWeight = "500";
  wrapper.appendChild(text);

  if (closable) {
    wrapper.appendChild(createCloseButton(removeProcessingToast));
  }

  document.body.appendChild(wrapper);

  if (autoHide) {
    window.setTimeout(removeProcessingToast, SUCCESS_HIDE_DELAY_MS);
  }

  return true;
}

function pushStackedToast({ type, message }) {
  const config = TOAST_CONFIG[type] || TOAST_CONFIG.info;

  const wrapper = document.createElement("div");
  wrapper.setAttribute("role", type === "error" ? "alert" : "status");
  wrapper.setAttribute("aria-live", type === "error" ? "assertive" : "polite");

  wrapper.style.position = "fixed";
  wrapper.style.right = "24px";
  wrapper.style.top = `${STACK_TOP_OFFSET}px`;
  wrapper.style.opacity = "0";
  wrapper.style.transform = "translateX(24px)";
  wrapper.style.transition =
    "top 0.3s ease, opacity 0.25s ease, transform 0.25s ease";
  styleToastWrapper(wrapper, config);

  appendToastIcon(wrapper, config.icon);

  const text = document.createElement("div");
  text.textContent = message;
  text.style.flex = "1";
  text.style.fontWeight = "500";
  wrapper.appendChild(text);

  wrapper.appendChild(
    createCloseButton(() => removeStackedToast(wrapper))
  );

  document.body.appendChild(wrapper);

  stackedToasts.unshift({ el: wrapper, timer: null });
  repositionStackedToasts();

  requestAnimationFrame(() => {
    wrapper.style.opacity = "1";
    wrapper.style.transform = "translateX(0)";
  });

  const entry = stackedToasts.find(item => item.el === wrapper);
  if (entry) {
    entry.timer = window.setTimeout(
      () => removeStackedToast(wrapper),
      STACKED_TOAST_HIDE_DELAY_MS
    );
  }
}

export function showAppNotification({ type = "info", message }) {
  appNotificationQueue.push({ type, message });

  if (!appNotificationTimer) {
    appNotificationTimer = window.setInterval(() => {
      const notification = appNotificationQueue.shift();

      if (!notification) {
        window.clearInterval(appNotificationTimer);
        appNotificationTimer = null;
        return;
      }

      pushStackedToast(notification);
    }, APP_NOTIFICATION_DELAY_MS);
  }

  return true;
}

export function showProcessingNotification({
  message = "Deine Eingaben wurden gespeichert. Die Daten werden jetzt validiert, verarbeitet und für das Dashboard berechnet.",
} = {}) {
  return createToast({
    type: "processing",
    message,
    closable: false,
    autoHide: false,
  });
}

export function showProcessingSuccessNotification({
  message = "Dashboard wurde aktualisiert.",
} = {}) {
  return createToast({
    type: "success",
    message,
    closable: true,
    autoHide: true,
  });
}

export function showProcessingErrorNotification({
  message = "Die neuen Dashboard-Daten konnten nicht geladen werden. Bitte versuche es erneut.",
} = {}) {
  return createToast({
    type: "error",
    message,
    closable: true,
    autoHide: false,
  });
}

export function hideProcessingNotification() {
  removeProcessingToast();
}
